import React from 'react';
import { motion } from 'framer-motion';
export function Divider() {
  return <div className="w-full flex justify-center items-center py-4 opacity-80" data-id="element-356">
      <motion.div initial={{
      scaleX: 0,
      opacity: 0
    }} whileInView={{
      scaleX: 1,
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1,
      delay: 0.2
    }} className="flex items-center w-full max-w-xs" data-id="element-357">
        <div className="h-[1px] flex-1 bg-tea-gold/50" data-id="element-358"></div>
        <div className="mx-4 text-tea-gold" data-id="element-359">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-360">
            <path d="M12 2L14.4 9.6H22L15.8 14.2L18.2 21.8L12 17.2L5.8 21.8L8.2 14.2L2 9.6H9.6L12 2Z" fill="currentColor" fillOpacity="0.4" data-id="element-361" />
          </svg>
        </div>
        <div className="h-[1px] flex-1 bg-tea-gold/50" data-id="element-362"></div>
      </motion.div>
    </div>;
}